/** @format */

import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { roles, UserRoleHelper } from '../helpers/UserRoleHelper';
import Certificate from '../layouts/Certificate';
import { Auth } from '../modules/auth/Auth';

export const AuthorizationCheckRouter = ({ component: Component, ...rest }) => (
    <Route
        {...rest}
        render={(props) => {
            let component = <Component {...props} />;
            if (UserRoleHelper.checkRole(roles.ROLE_PRE_CERTIFICATE_GET, true)) {
                component = <Certificate {...props} />;
            }

            if (Auth.isExpired() || !Auth.isSameBrowser()) {
                Auth.clearToken();
            }

            return Auth.getAccessToken() ? (
                component
            ) : (
                <Redirect to={{ pathname: process.env.REACT_APP_LOGIN_PAGE, state: { from: props.location } }} />
            );
        }}
    />
);
